<template>
<div class="mt-4 md:mt-10">
  <p
    v-show="brandService.getName() !== Brand.BLM"
    :class="brandService.getName() === Brand.HIS ? 'font-gotham-medium text-gray-500' : 'font-poppins text-white'" class="text-18 leading-6 ">Enter your address to get started:
  </p>
  <div class="my-2 py-2 md:py-4">
    <div
      v-show="brandService.getName() !== Brand.BLM"
      class="mb-2 md:mb-8 relative"
    >
      <input v-if="brandService.getName() === Brand.HIS" @keyup="handleAddressSearchInputted" @paste="handleAddressSearchInputted" v-model="addressInput" autocomplete="off" type="text" name="address-search" id="primary-address-search" class="transition duration-250 shadow-sm rounded-md border-solid border-gray-200 appearance-none min-w-0 w-3/4 bg-white border border-transparent rounded-lg py-4 px-4 text-base md:text-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-brand-secondary focus:ring-gray-50 focus:border-brand-secondary focus:placeholder-gray-400" placeholder="1/20 Example Street, Sydney" />
      <input v-if="brandService.getName() === Brand.NEX" @keyup="handleAddressSearchInputted" @paste="handleAddressSearchInputted" v-model="addressInput" autocomplete="off" type="text" name="address-search" id="primary-address-search" class="transition duration-250 shadow-sm rounded-full border border-gray-200 appearance-none min-w-0 max-w-xs md:max-w-lg w-full bg-white border border-transparent py-4 px-4 text-base md:text-18 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-brand-secondary focus:ring-gray-50 focus:border-brand-secondary focus:placeholder-gray-400 bg-opacity-60 font-poppins" placeholder="Enter your home address" />

      <transition v-if="brandService.getName() === Brand.NEX" leave-active-class="transition duration-250" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div  class="absolute border border-gray-200 rounded-md shadow-sm mt-1 bg-opacity-90 bg-white z-50 h-64 overflow-auto w-full max-w-lg font-poppins ml-4 " v-show="autocompletedAddresses.length">
          <div @click="handleAutocompletedAddressClicked(address)" class="py-2 px-4 cursor-pointer hover:bg-black hover:text-white text-left" v-for="address in autocompletedAddresses" :key="address.id">{{ address.address }}</div>
        </div>
      </transition>
      <transition v-if="brandService.getName() === Brand.HIS" leave-active-class="transition duration-250" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div class="absolute bg-white border border-gray-200 rounded-md shadow-sm mt-2 z-50 h-64 overflow-auto w-full" v-show="autocompletedAddresses.length">
          <div @click="handleAutocompletedAddressClicked(address)" class="p-4 cursor-pointer hover:bg-brand-button-hover text-left font-gotham-medium" v-for="address in autocompletedAddresses" :key="address.id">{{ address.address }}</div>
        </div>
      </transition>
    </div>
    <div
      v-show="brandService.getName() === Brand.HIS"
      class=""
    >
      <AsyncButton @onClick="handleCheckAddressClicked">Check Address!</AsyncButton>
    </div>
    <div
      v-show="brandService.getName() === Brand.NEX"
      class=""
    >
      <AsyncButton @onClick="handleCheckAddressClicked">Check your Address</AsyncButton>
    </div>
    <div
      v-show="brandService.getName() === Brand.BLM"
      class=""
    >
      <button
        class="shadow-sm transition duration-250 w-full lg:w-auto flex items-center justify-center px-6 py-4 text-base md:text-md rounded-lg text-brand-button-text bg-brand-button hover:bg-brand-button-hover md:text-lg md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent border-white border-2"
        >
        <a href="https://unitiinternet.com?from=bloom">Go to Uniti Internet</a>
      </button>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { Address } from '@/adapters/autocompleteAddressAdapterInterface';
import { defineEmits, defineProps, ref, watch } from 'vue';
import AsyncButton from '../library/AsyncButton.vue';
import { Brand } from '../../services/integration/enums';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Events.
const emit = defineEmits<{(e: 'onCheckAddressClicked', address: string, done: () => void): void, (e: 'onAddressSearchInputted', address: string): void, (e: 'onAutocompletedAddressClicked', address: Address): void}>();

// Props.
const props = defineProps<{
  autocompletedAddresses: Array<Address>,
  address: string
}>();

// Data.
const addressInput = ref('');
let debounce: number | null = null;

// Watch data.
watch(() => props.address, (selection) => {
  addressInput.value = selection;
});

// Alert parents that the user has typed
// into the address search input.
const handleAddressSearchInputted = () => {
  if (debounce !== null) {
    clearTimeout(debounce);
  }

  if (addressInput.value.length > 4) {
    debounce = setTimeout(() => {
      emit('onAddressSearchInputted', addressInput.value);
    }, 300);
  }
};

// Alert parents that the user has submitted
// the address.
const handleCheckAddressClicked = (done: () => void) => {
  emit('onCheckAddressClicked', addressInput.value, done);
};

// Alert parents that an address from the autocomplete
// has been clicked.
const handleAutocompletedAddressClicked = (autocompletedAddress: Address) => {
  emit('onAutocompletedAddressClicked', autocompletedAddress);
};
</script>
